import axios from 'utils/axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';


import { showSuccessModal } from 'actions';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response; 
  if (res?.status === 422){ 
    dispatch({ type: validationType, validation_error: res.data.errors });
  } 
  else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

export const brandRedirectToList = () => ({ type: types.BRANDS_REDIRECT });

const fetchSuccess = (type, listKey) => data => ({
  type,
  [listKey]: data
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action
});

export const hideBrandValidationError = (feild_key) => ({
  type: types.HIDE_BRANDS_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const fetchBrands = (params = {}) => dispatch => {
  dispatch({ type: types.BRANDS_REQUEST });
  dispatch(loader());

  axios.post(`${API_URL}admin/brands/list`, params, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.BRANDS_SUCCESS, 'brandsList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.BRANDS_VALIDATION_ERROR);
    });
};

export const getBrandById = (id, actionType, object_viewed_id) => dispatch => {
  dispatch({ type: types.BRANDS_REQUEST });
  dispatch(loader());

  axios.get(`${API_URL}admin/brands/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.BRANDS_GET_SUCCESS)(res.data, actionType));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.BRANDS_VALIDATION_ERROR);
    });
};

export const createOrUpdateBrand = (data, method = 'POST', object_viewed_id) => dispatch => {
  dispatch({ type: types.BRANDS_REQUEST });
  dispatch(loader());

  const url = method === 'POST'
    ? `${API_URL}admin/brands`
    : `${API_URL}admin/brands/${data.id}`;

  axios({
    url,
    method,
    data,
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(showSuccessModal(`Brand ${method === 'POST' ? 'created' : 'updated'} successfully`));
      dispatch(brandRedirectToList());
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.BRANDS_VALIDATION_ERROR);
    });
};

export const deleteBrand = (id, object_viewed_id) => dispatch => {
  dispatch({ type: types.BRANDS_REQUEST });
  dispatch(loader());

  axios.delete(`${API_URL}admin/brands/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar('Brand deleted', 'success'));
      dispatch(fetchBrands({ object_viewed_id })); // Refetch list after delete
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.BRANDS_VALIDATION_ERROR);
    });
};

export const fetchBrandsDropdown = (params) => dispatch => {
  dispatch({ type: types.BRANDS_REQUEST });
  axios.get(`${API_URL}admin/brands/dropdown`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    params
  })
    .then(res => {
      dispatch(fetchSuccess(types.BRANDS_DROPDOWN_SUCCESS, 'brandsDropdownList')(res.data));
    })
    .catch(err => {
      handleError(err, dispatch, types.BRANDS_VALIDATION_ERROR);
    });
};

export const exportBrands = (extraFilters, object_viewed_id) => dispatch => {
  dispatch(loader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL}admin/brands/export`;

  axios.post(url, {...extraFilters, object_viewed_id}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'brands.xlsx';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch.length > 1)
            filename = filenameMatch[1];
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideLoader());
  }).catch(error => {
    dispatch(hideLoader());
    handleError(error, dispatch);
  });
};
